export enum AdminLevelActiveExtended {
  ACTIVE = 'ACTIVE',
  INACTIVE_NONE = 'INACTIVE_NONE',
  INACTIVE_LINK = 'INACTIVE_LINK',
  INACTIVE_OPEN311 = 'INACTIVE_OPEN311',
}
